/*
 * prescription (schema)
 */
import { boolean, doublePrecision, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { patients } from "../patient/patient.schema"
import { practitioners } from "../practitioner/practitioner.schema"

export const prescriptions = schema.table("prescriptions", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),
	practitionerId: uuid("practitioner_id").references(() => practitioners.id, {
		onDelete: "set null",
	}),
	appointmentId: uuid("appointment_id"),

	// --- Diagnosis ---
	primaryDiagnosisId: uuid("primary_diagnosis_id"),
	secondaryDiagnosisId: uuid("secondary_diagnosis_id"),
	fullDiagnosisText: text("full_diagnosis_text"),
	soapNote: text("soap_note"),

	// --- Dosage ---
	amount: doublePrecision("amount"),
	minThc: doublePrecision("min_thc"),
	maxThc: doublePrecision("max_thc"),
	minCbd: doublePrecision("min_cbd"),
	maxCbd: doublePrecision("max_cbd"),

	// --- Flags ---
	insuranceCoverage: boolean("insurance_coverage").notNull().default(false),
	vaporizerRx: boolean("vaporizer_rx").notNull().default(false),
	isLatest: boolean("is_latest").notNull().default(true),

	// --- Dates ---
	startDate: timestamp("start_date", { withTimezone: true }),
	endDate: timestamp("end_date", { withTimezone: true }),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
